module.exports = __webpack_public_path__ + "92042ad4934eff143f84ab4d057f829e.pdf";